import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCurrentUser } from '../../services/authService';
import Button from '../../components/common/Button';
import './Dashboard.css';

/**
 * Dashboard component
 * Main landing page after authentication
 */
const Dashboard = () => {
  const [, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const { user } = await getCurrentUser();
      setUser(user);
      setLoading(false);
    };

    fetchUser();
  }, []);

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Welcome to Unissn</h1>
        <p>Your music industry connection hub</p>
      </div>

      <div className="dashboard-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bi bi-person-circle"></i>
          </div>
          <h3>Your Profile</h3>
          <p>Complete your profile to increase visibility</p>
          <Link to="/profile" style={{ width: '100%' }}>
            <Button variant="primary" fullWidth={true}>Edit Profile</Button>
          </Link>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <i className="bi bi-calendar-event"></i>
          </div>
          <h3>Gigs</h3>
          <p>Find or post gigs in your area</p>
          <Link to="/gigs" style={{ width: '100%' }}>
            <Button variant="primary" fullWidth={true}>Browse Gigs</Button>
          </Link>
        </div>
      </div>

      <div className="dashboard-section">
        <h2>Getting Started</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-icon">
              <i className="bi bi-person-vcard"></i>
            </div>
            <h3>Complete Profile</h3>
            <p>Add your skills, experience, and portfolio</p>
            <Link to="/profile" style={{ marginTop: 'auto', width: '100%' }}>
              <Button variant="outline" size="small" fullWidth={true}>Start Now</Button>
            </Link>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <div className="step-icon">
              <i className="bi bi-search"></i>
            </div>
            <h3>Explore Gigs</h3>
            <p>Find opportunities that match your skills</p>
            <Link to="/gigs" style={{ marginTop: 'auto', width: '100%' }}>
              <Button variant="outline" size="small" fullWidth={true}>Browse Gigs</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
